import React, { HTMLAttributes, KeyboardEvent } from 'react';

import { Title } from '../Title';

import style from './styles.module.css';

export interface ModalProps extends HTMLAttributes<HTMLDivElement> {
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
}

export const Modal: React.FC<ModalProps> = ({
  children,
  isOpen,
  onClose,
  title,
  ...props
}: ModalProps) => {
  const handleKeyDown = (e: KeyboardEvent) => {
    e.stopPropagation();

    if (e.key === 'Escape') {
      onClose && onClose();
    }
  };

  return (
    <div
      role="presentation"
      className={`${style.modalOverlay} ${isOpen ? style.open : style.close}`}
      onClick={onClose}
      onKeyDown={handleKeyDown}
    >
      <div className={style.modalContent} {...props}>
        <header className={style.modalHeader}>
          {title && <Title title={title} />}
        </header>
        <div className={style.modalBody}>{children}</div>
      </div>
    </div>
  );
};
